export { apiMindbox } from 'next-flight-server-reference-proxy-loader?id=7f3db731a9ab4cd7682ce798e63cd74badd852794f&name=apiMindbox!'